import { Image as ImageProps } from 'src/types/Image';
import Image from 'next/image';
import classNames from 'classnames';
import styles from './card.module.scss';

export interface CardGenericProps {
    className?: string;
    image: ImageProps & {
        split?: ImageProps[];
        raw?: boolean;
    };
    children?: React.ReactNode;
    sectionClassName?: string;
}

const CardGeneric = (props: CardGenericProps) => {
    return (
        <article className={classNames(styles['generic'], props.className)}>
            <header
                className={classNames(props.image?.split && styles['split'])}
            >
                {props.image?.split ? (
                    <picture>
                        {props.image.split.map((image, index) => (
                            <Image
                                key={index}
                                {...image}
                                alt={image.alt}
                                unoptimized={!!props.image.raw}
                            />
                        ))}
                    </picture>
                ) : props.image ? (
                    <Image
                        {...props.image}
                        alt=""
                        unoptimized={!!props.image.raw}
                    />
                ) : null}
            </header>
            <section className={props.sectionClassName}>
                {props.children && props.children}
            </section>
        </article>
    );
};

export default CardGeneric;
